import React from 'react'
import { useState, useEffect } from 'react'
import { RESET_PASS } from '../helpers/api'
import { SHA_Encryption } from '../helpers/token'
import queryString from 'query-string';
import { useLocation, useNavigate } from "react-router-dom"




function ResetPassword() {
    const navigate = useNavigate()
    const location = useLocation();
    const token = queryString.parse(location.search).token || null;

    const [data, setData] = useState({ otp: "", password: "" })

    const handleotp = (e) => {
        setData({ ...data, otp: e.target.value })
    }
    const handlepass = (e) => {
        setData({ ...data, password: e.target.value })
    }

    const resetpass = async () => {
        try {
            const payload = {
                otp: data.otp,
                password: SHA_Encryption(data.password)
            }
            console.log(payload);
            const response = await RESET_PASS(payload, token)
            if (response.success) {
                alert("password updated")
                navigate("/sign-in")
            }
        }
        catch (e) {
            console.log(e);
        }
    }


    useEffect(() => {
        if (token == null) {
            // navigate("/sign-in")
            alert("invalid token")
        } else {
            alert(token)
        }

    }, [])




    return (
        <>
            <section className='reset_sec'>
                <div className="container">
                    <div className="card jc-center">
                        <h3 className='mb-5'>Reset Password</h3>
                        <div className="mb-3">
                            <label className="form-label mb-2">OTP</label>
                            <input type="text" onChange={(e) => handleotp(e)} className="form-control" placeholder='Enter here' required />
                        </div>
                        <div className="mb-5">
                            <label className="form-label mb-2">Password</label>
                            <input type="password" onChange={(e) => handlepass(e)} className="form-control" placeholder='Enter here' required />
                        </div>
                        <div className="mb-3">
                            <button onClick={() => resetpass()} className="btn sign_btn">Update</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ResetPassword
